<template>
  <div class="grid-node" :style="`--grid-template-columns: ${gridTemplateColumns}; --grid-gap: ${gridGap}`">
    <form-node v-for="(item, i) in content" :key="i" v-bind="item" v-on="$listeners" />
  </div>
</template>

<script>
import { PropsDefinition, Computed } from '@/_typedefs'
import { FormNodeProps } from '../FormNode.vue'

/**
 * @typedef {Object} GridNodeProps
 * @property {number} [rowGap]
 * @property {number} [columnGap]
 * @property {number} [gap]
 * @property {number} cols
 * @property {FormNodeProps[]} content
 */

export default {
  name: 'GridNode',
  /** @type {PropsDefinition<GridNodeProps>} */
  props: {
    cols: {
      type: Number,
      default: 3,
    },
    gap: {
      type: Number,
      default: null,
    },
    rowGap: {
      type: Number,
      default: 4,
    },
    columnGap: {
      type: Number,
      default: 4,
    },
    content: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    /** @type {Computed<string>} */
    gridTemplateColumns() {
      return `repeat(${this.cols}, 1fr)`
    },
    /** @type {Computed<string>} */
    gridGap() {
      if (this.gap) {
        return `${this.gap * 4}px`
      }

      return `${this.rowGap * 4}px ${this.columnGap * 4}px`
    },
  },
}
</script>

<style scoped>
.grid-node {
  display: grid;
  grid-template-columns: var(--grid-template-columns);
  gap: var(--grid-gap);
}
</style>
